import React from 'react';

import Dropdown from '@appComponents/Dropdown/Dropdown';
import CurrencyElement from '@appComponents/CurrencyElement/CurrencyElement';
import ToolTip from '@appComponents/ToolTip/ToolTip';
import Big from 'big.js';

import IWalletToPurchaseSelect from './IWalletToPurchaseSelect';
import { classNames } from '@features/utils/reactFunctions';
import { renameMainCurrency } from '@features/utils/functions';

import * as style from './WalletToPurchaseSelectStyle.module.scss'

const WalletToPurchaseSelect: React.SFC<IWalletToPurchaseSelect> = (props: IWalletToPurchaseSelect) => {

  const dropdownData = () =>
    props.availableToPayWallets
      .map(el => ({
        id: el.id,
        name: el.currency === 'usd' ? 'US Dollar / USDT' : el.currency_name,
        slug: el.currency,
      }));

  const roundedValue = Big(props.priceFor1Token).round(8, 0);

  return (
    <>
      <div className={classNames(style.walletToPurchaseSelectFlex, style.walletToPurchaseSelectFlexOneRow)}>
        <div className={style.walletToPurchaseSelectInputWrapper}>
          <label>{props.label}</label>
          <div className={style.walletToPurchaseSelectDropdownMargin}>
            <Dropdown
              currency={props.currencyToPay!}
              data={dropdownData()}
              update={props.handleUpdate}
              initialValue={props.isInitialValue && !props.currencyToPay ? 'Select option' : undefined}
            />
          </div>
        </div>
        <div
          className={classNames(
            style.walletToPurchaseSelectTokenEstimation,
            process.env.ENABLE_BINANCE_TRADING && style.moveToRight
          )}
        >
          <p className={style.walletToPurchaseSelectTokenEstimationLabel}>Price:</p>
          {props.priceFor1Token ? (
            <div>
              <CurrencyElement value="1" currency={props.currency} />
              ~
              <CurrencyElement
                value={props.priceFor1Token}
                currency={props.currencyToPay}
              />
              <ToolTip
                maxWidth={300}
                className={style.tooltip}
                text={
                  <>
                    {roundedValue.toString()}
                    <span> {renameMainCurrency(props.currencyToPay).toUpperCase()}</span>
                  </>
                }
              >
                &nbsp; &#9432;
              </ToolTip>
            </div>

          ) : (
            <ToolTip
              maxWidth={300}
              text="To display price, please select currency"
            >
              &#9432;
            </ToolTip>
          )}
        </div>
      </div>
    </>
  );
};

export default WalletToPurchaseSelect;
